import { render, staticRenderFns } from "./ScenarioSlide.vue?vue&type=template&id=656f57af"
import script from "./ScenarioSlide.vue?vue&type=script&lang=js"
export * from "./ScenarioSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('656f57af')) {
      api.createRecord('656f57af', component.options)
    } else {
      api.reload('656f57af', component.options)
    }
    module.hot.accept("./ScenarioSlide.vue?vue&type=template&id=656f57af", function () {
      api.rerender('656f57af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/ScenarioSlide.vue"
export default component.exports